/* eslint-disable import/no-mutable-exports */
/* eslint-disable no-var */
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";

class CommentHub {
  constructor() {
    this.connection = null;
  }

  createConnection(axios) {
    const url = axios.defaults.baseURL.substring(0, axios.defaults.baseURL.lastIndexOf("/api"));
    this.connection = new HubConnectionBuilder()
      .withUrl(`${url}/applicationHub`, {
        accessTokenFactory: () => `${localStorage.getItem("token")}`
      })
      .configureLogging(LogLevel.Error)
      .build();
  }

  async start() {
    try {
      await this.connection.start();
      console.log("connected started");
    } catch (err) {
      console.log(`Connection failed: ${err}`);
    }
  }

  disconnect() {
    if (this.connection) {
      this.connection.stop();
    }
  }

  onCloseConnection() {
    if (this.connection) {
      this.connection.onclose(() => {
        console.log("disconnected");
      });
    }
  }

  joinGroup(groupGuid) {
    if (this.connection) {
      this.connection
        .invoke("JoinGroup", groupGuid, "Comments")
        .catch(err => {
          console.log(err);
        });
    }
  }

  leaveGroup(groupGuid) {
    if (this.connection) {
      this.connection.invoke("LeaveGroup", groupGuid).catch(err => {
        console.log(err);
      });
    }
  }

  createComment(callback) {
    if (this.connection) {
      this.connection.on("CreateComment", callback);
    }
  }

  updateComment(callback) {
    if (this.connection) {
      this.connection.on("UpdateComment", callback);
    }
  }

  deleteComment(callback) {
    if (this.connection) {
      this.connection.on("DeleteComment", callback);
    }
  }
}

export default CommentHub;
